import { axios } from '../../services/axios';

const getAllServiceDefinitions = ({ wholesalerID, scope }) => {
    return axios.get(
        `/ServiceProfile/OperatorPlatform/Wholesaler/${wholesalerID}/ServiceDefinitions`,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
};

export default getAllServiceDefinitions;
